import './oiProfile.css';
import React, { Component } from 'react';

import axios from 'axios';
import History from '../../History';
import Dropzone from 'react-dropzone';
import LeftAngleIcon from 'react-icons/lib/fa/angle-left';
import RightAngleIcon from 'react-icons/lib/fa/angle-right';

import OiModal from '../oiModal/oiModal';
import OiLoading from '../oiLoading/oiLoading';

class oiProfile extends Component {
    state = {
        userName: '',
        nameFlag: true,
        avatarImage: '',
        isLoading: true,
        modalIsOpen: false,
        listOfCategories: [],
        selectedCategory: '',
        msisdn: sessionStorage.getItem('msisdn'),
        isBundle: sessionStorage.getItem('isBundle'),
        userData: sessionStorage.getItem('userData'),
        phoneNumber: sessionStorage.getItem('phoneNumber'),
        modal: {
            title: null,
            text: null,
            btn1: null,
            btn2: null,
            event1: null,
            event2: null
        }
    };

    componentDidMount = () => {
        if (!sessionStorage.getItem("msisdn") || !sessionStorage.getItem("sessionToken") || this.state.isBundle === 'yes') {
            History.push(`${process.env.PUBLIC_URL}/`);
        }

        this.getUserData(() => {
            if (JSON.parse(sessionStorage.getItem('userData'))) {
                this.setState(
                    {
                        isLoading: false,
                        userName: JSON.parse(sessionStorage.getItem('userData')).name,
                        avatarImage: JSON.parse(sessionStorage.getItem('userData')).avatar
                    }
                );
            }
            else {
                this.setState({ userName: null, avatar: null, isLoading: false });
            }

            setTimeout(() => { this.refreshToken() }, (10 * 60 * 1000));
        });
    }

    manageModalWithCallback = (callback) => {
        this.setState({ modalIsOpen: !this.state.modalIsOpen });

        callback();
    }

    logout = () => {
        sessionStorage.clear();
        History.push(`${process.env.PUBLIC_URL}/`);
    };

    refreshToken = () => {
        //API REFRESH TOKEN
        let self = this;
        let url = 'https://api.oston.io/clicnoticia/v1/auth/token/refresh';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.post(url, {}, config)
            .then(refresh => {
                sessionStorage.setItem('sessionToken', refresh.data.token);
                setTimeout(() => { self.refreshToken() }, (10 * 60 * 1000));
            })
            .catch(error => {
                sessionStorage.removeItem('sessionToken');

                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Sua sessão expirou. Por favor, faça login novamente.',
                        btn1: 'Ir para o login',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/`);
                            })
                        }
                    }
                });
            });
    }

    getUserData = (callback) => {
        //API GET PROFILE
        let self = this;
        let url = 'https://api.oston.io/clicnoticia/v1/profile';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.get(url, config)
            .then(userData => {
                if (userData.data.user.data !== null) {
                    if (userData.data.user.data.interests.length > 0) {
                        this.setState({ userData: JSON.stringify(userData.data.user), userName: userData.data.user.name }, () => {
                            sessionStorage.setItem('userData', JSON.stringify(userData.data.user));

                            if (callback) {
                                callback();
                            }
                        });
                    }
                    else {
                        sessionStorage.setItem('userData', JSON.stringify(userData.data.user));
                        History.push(`${process.env.PUBLIC_URL}/interesses`);
                    }
                }
                else {
                    sessionStorage.setItem('userData', JSON.stringify(userData.data.user));
                    History.push(`${process.env.PUBLIC_URL}/interesses`);
                }
            })
            .catch(error => {
                sessionStorage.removeItem('sessionToken');

                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao buscar os dados do usuário. Por favor, faça login novamente.',
                        btn1: 'Ir para o login',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/`);
                            })
                        }
                    }
                });
            });
    }

    changeNameHandler = (event) => {
        event.preventDefault();
        this.setState({ isLoading: true });

        if (this.state.userName !== '' && this.state.userName !== null && this.state.userName !== undefined) {
            //API UPDATE PROFILE - NAME
            let self = this;
            let url = 'https://api.oston.io/clicnoticia/v1/profile';
            const config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
                }
            };

            let newUser = JSON.parse(sessionStorage.getItem('userData'));
            newUser.name = this.state.userName;

            axios.put(url, newUser, config)
                .then(response => {
                    this.setState({ nameFlag: true, isLoading: false },
                        () => {
                            sessionStorage.setItem('userData', JSON.stringify(newUser));
                        });
                })
                .catch(error => {
                    self.setState({
                        modalIsOpen: true,
                        isLoading: false,
                        modal: {
                            title: 'Falha',
                            text: 'Falha ao alterar o nome, por favor tente novamente.',
                            btn1: 'Entendi',
                            event1: () => {
                                self.manageModalWithCallback(() => {
                                    self.setState({ nameFlag: true, isLoading: false });
                                });
                            }
                        }
                    });
                });
        }
        else {
            this.setState({ nameFlag: true });
        }
    }

    getInputValue = (event) => {
        event.preventDefault();

        this.setState({ userName: event.target.value.trim() });
    }

    preview = (event, callback) => {
        let self = this;
        let files = event;
        let firstFile = files;
        let reader = new FileReader();

        reader.addEventListener("load", function (a) {
            self.setState({ avatarImage: reader.result });

            callback(reader.result);
        }, false);

        if (firstFile) {
            reader.readAsDataURL(firstFile);
        }
    }

    onDrop = (droped) => {
        let file = droped[0];
        this.setState({ isLoading: true });

        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            this.setState({
                modalIsOpen: true,
                isLoading: false,
                modal: {
                    title: 'Atenção',
                    text: 'Formatos de imagem suportados: JPG e PNG. Tente novamente.',
                    btn1: 'Entendi',
                    event1: () => {
                        this.manageModalWithCallback(() => {
                            this.setState({ isLoading: false });
                        });
                    }
                }
            });
        }
        else if (file.size > 1000000) {
            this.setState({
                modalIsOpen: true,
                isLoading: false,
                modal: {
                    title: 'Atenção',
                    text: 'Tamanho máximo da imagem: 1MB. Tente novamente.',
                    btn1: 'Entendi',
                    event1: () => {
                        this.manageModalWithCallback(() => {
                            this.setState({ isLoading: false });
                        });
                    }
                }
            });
        }
        else {
            //API UPLOAD - AVATAR
            let self = this;
            let url = 'http://authorization.oston.io/api/user/avatar';
            const config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
                }
            };

            this.preview(file, (avatarImage) => {
                let form = new FormData();
                form.append('avatar', file);

                let newUser = JSON.parse(sessionStorage.getItem('userData'));
                newUser.avatar = avatarImage;

                axios.post(url, form, config)
                    .then(response => {
                        this.setState({ isLoading: false, userData: newUser },
                            () => {
                                sessionStorage.setItem('userData', JSON.stringify(newUser));
                                window.URL.revokeObjectURL(file);
                            });
                    })
                    .catch(error => {
                        self.setState({
                            modalIsOpen: true,
                            isLoading: false,
                            modal: {
                                title: 'Falha',
                                text: 'Falha ao alterar o avatar, por favor tente novamente.',
                                btn1: 'Entendi',
                                event1: () => {
                                    self.manageModalWithCallback(() => {
                                        self.setState({ isLoading: false });
                                    });
                                }
                            }
                        });
                    });
            });
        }
    }

    render = () => {
        return (
            <div id="oi-profile">
                {this.state.isLoading ? <OiLoading /> : ''}
                {this.state.modalIsOpen ? <OiModal modal={this.state.modal} /> : ''}
                {!this.state.nameFlag ? <div id="name-flag-layer" onClick={() => { this.setState({ nameFlag: true }) }}></div> : ''}

                <header>

                    <LeftAngleIcon
                        id="oi-profile-back-icon"
                        onClick={() => { History.push(`${process.env.PUBLIC_URL}/noticias`) }}
                    />

                    <div id="oi-profile-images-box">
                        <Dropzone
                            id="dropzone"
                            multiple={false}
                            onDrop={this.onDrop.bind(this)}
                        >

                            <img
                                alt="Avatar"
                                src={this.state.avatarImage ? this.state.avatarImage : `${process.env.PUBLIC_URL}` + '/imgs/default-avatar.png'}
                                id="oi-profile-img-avatar"
                            />

                        </Dropzone>
                    </div>

                    {
                        this.state.nameFlag ?
                            <h1 onClick={() => { this.setState({ nameFlag: false }) }}>
                                {
                                    this.state.userName ?
                                        this.state.userName :
                                        'Alterar o Nome'
                                }
                            </h1>
                            :
                            <form onSubmit={(event) => { this.changeNameHandler(event) }}>
                                <input
                                    type="text"
                                    maxLength="25"
                                    autoFocus={false}
                                    id="oi-profile-input-name"
                                    placeholder="Digite seu nome"
                                    onChange={(event) => { this.getInputValue(event) }}
                                />
                            </form>
                    }

                    <p>{this.state.phoneNumber}</p>

                </header>

                <div className="link-stripe" onClick={() => { History.push(`${process.env.PUBLIC_URL}/interesses`) }}>
                    <p>Definir Interesses</p>
                    <RightAngleIcon
                        className="oi-profile-go-icon" />
                </div>

                <div className="link-stripe" onClick={() => { History.push(`${process.env.PUBLIC_URL}/sobre`) }}>
                    <p>Termos de Uso</p>
                    <RightAngleIcon
                        className="oi-profile-go-icon" />
                </div>

                <span id="oi-profile-logout" onClick={() => { this.logout() }}>Encerrar Sessão</span>

            </div>
        );
    }
};

export default oiProfile;


// WEBPACK FOOTER //
// ./src/components/oiProfile/oiProfile.js